import { Skeleton, Row, Divider } from '../../../components/Generic';
import { Content, Grid } from '../styles';

const LoadingComponent = () => (
  <Content>
    <Skeleton
      style={{
        height: 16,
        width: '40%',
        borderRadius: 6,
        marginBottom: 15,
      }}
    />

    <Skeleton
      style={{
        height: 38,
        width: '100%',
        borderRadius: 8,
      }}
    />

    <Grid>
      <Skeleton
        style={{
          height: 110,
          width: 110,
          gridRow: '1 / 3',
          borderRadius: 8,
        }}
      />

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 80, marginTop: 3 }} />
      </div>

      <div />

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 100, marginTop: 3 }} />
      </div>

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 70, marginTop: 3 }} />
      </div>

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 70, marginTop: 3 }} />
      </div>

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 70, marginTop: 3 }} />
      </div>

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 70, marginTop: 3 }} />
      </div>

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 70, marginTop: 3 }} />
      </div>

      <div>
        <Skeleton style={{ height: 14, width: 40 }} />
        <br />
        <Skeleton style={{ height: 16, width: 70, marginTop: 3 }} />
      </div>
    </Grid>

    <Row
      style={{
        justifyContent: 'space-between',
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      <Skeleton style={{ height: 60, width: '48%', borderRadius: 8 }} />
      <Skeleton style={{ height: 60, width: '48%', borderRadius: 8 }} />
    </Row>

    <Row
      style={{
        justifyContent: 'space-between',
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      <Skeleton style={{ height: 35, width: '48%', borderRadius: 8 }} />
      <Skeleton style={{ height: 35, width: '48%', borderRadius: 8 }} />
    </Row>

    <Divider />

    <Row
      style={{
        justifyContent: 'space-between',
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      <Skeleton style={{ height: 60, width: '48%', borderRadius: 8 }} />
      <Skeleton style={{ height: 60, width: '48%', borderRadius: 8 }} />
    </Row>

    <Skeleton style={{ height: 14, width: 120 }} />
  </Content>
);

export default LoadingComponent;
